import React from 'react'
import { Link } from 'app/common/link'
import { media } from 'app/assets/styles'
import styled from 'styled-components'
import { H4, Text } from 'app/common/typography'
import type { MarketingAnimationShortDTO } from 'shared/types'
import type { EventMetadata } from 'shared/store/metadata'
import { Picture } from 'app/common/picture'
import ReactPlayer from 'react-player'

type Props = {
    marketingAnimation: MarketingAnimationShortDTO,
    maxWidth: boolean,
    meta?: Array<EventMetadata> | EventMetadata,
    noRatio?: boolean
}

const Card = (props: Props) => {
    const { meta, marketingAnimation, maxWidth, noRatio } = props
    const {
        imageUrlLandscape,
        imageUrlPortrait,
        imageUrlCropped,
        videoUrlLandscape,
        enableVideo,
        audio,
        autoPlay,
        repeat,
        imageTitle,
        actionColor,
        external,
        actionUrl,
        title,
        subtitle = ''
    } = marketingAnimation

    const pictures = {
        imageUrlLandscape,
        imageUrlPortrait,
        imageUrlCropped,
        imageTitle
    }

    return (
        <CardElement maxWidth={maxWidth}>
            <Link external={external} url={actionUrl} meta={meta}>
                <Content>
                    {enableVideo ? (
                        <ReactPlayer
                            wrapper={PlayerWrapper}
                            width={'100%'}
                            playsinline
                            muted={autoPlay || !audio}
                            playing={autoPlay}
                            loop={repeat}
                            key={videoUrlLandscape}
                            height={noRatio ? '1' : '8/5'}
                            controls={false}
                            config={{
                                file: {
                                    attributes: {
                                        poster: pictures.imageUrlCropped[0]
                                    }
                                }
                            }}
                            url={videoUrlLandscape}
                        />
                    ) : (
                        <PictureWrapper>
                            <Picture
                                {...pictures}
                                cropped
                                desktopRatio={noRatio ? '1' : '8/5'}
                                mobileRatio={noRatio ? '1' : '8/5'}
                            />
                        </PictureWrapper>
                    )}
                    <StyledH4 color={actionColor}>{title}</StyledH4>
                    <StyledText>{subtitle}</StyledText>
                </Content>
            </Link>
        </CardElement>
    )
}

const CardElement = styled.div`
    &:not(:last-of-type) {
        margin-right: 15px;
    }
    width: 270px;
    display: inline-block;
    ${media.medium`
        width: 100%;
        ${props => props.maxWidth && 'max-width: 270px'}; 
    `};
`
const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    img {
        border-radius: 10px;
        width: 100%;
    }
`
const StyledH4 = styled(H4)`
    margin-top: 10px;
    white-space: normal;
`

const StyledText = styled(Text)`
    white-space: normal;
`

const PictureWrapper = styled.div`
    padding-bottom: 10px;
`

const PlayerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    video {
        object-fit: cover;
        border-radius: 10px;
        display: block;
        margin: 0;
    }
`

export { Card }
